import dynamic from "next/dynamic";
const App = dynamic(() => import("../../components/App"));
import React, { useEffect, useState, useCallback } from "react";
import Head from "next/head";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  Row,
  Col,
  Space,
  Spin,
  Divider,
  Button,
  notification,
} from "antd";
import {
  DeleteOutlined,
  ShoppingOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useRouter } from "next/router";
import { convert } from "../../utils/convert";
import ThumborJS from "thumborjs";

const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

import { Api } from "../../networks/Api";
import { getCartData } from "../../redux/actions/cartActions";
import Summary from "../checkout/summary";

const { Title, Text } = Typography;

const openNotificationError = (msg) => {
  notification.open({
    message: "Notice",
    description: msg,
    placement: "top",
  });
};

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

function gtag_report_conversion() {
  const url = window.location.href;
  var callback = function () {
    if (typeof url != "undefined") {
      // window.location = url;
    }
  };
  // gtag("event", "conversion", {
  //   send_to: "AW-11311855547/Ils1CNCgvtwYELvv9JEq",
  //   event_callback: callback,
  // });
  return false;
}

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const router = useRouter();
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const [cartData, setCartData] = useState([]);
  const [totalprice, setTotalprice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [discountAll, setDiscountAll] = useState({});
  const [channel, setChannel] = useState("website");

  const redux_fingerprint = useSelector((state) => state?.fingerprint);
  const { currencyData } = useSelector((state) => state?.currency);
  const { currencyAllData } = useSelector((state) => state?.currencyAll);

  const fetchCartData = useCallback(async () => {
    setLoading(true);
    let discountAll = {};

    try {
      const url = `${Api.webpromotionAll}`;
      const res = await axios.get(url, Api.Header());
      if (res?.status == 200) {
        setDiscountAll(res?.data?.data);
        discountAll = res?.data?.data;
      }
    } catch (e) {
      // console.log("fetchData >> webpromotionAll error :", e);
    }

    try {
      const profileResponse = token
        ? await axios.get(Api.UserProfile, Api.Header(token))
        : {};
      const channel = profileResponse?.data?.data?.channel || "website";
      setChannel(channel);

      const url_cart = `${Api.getCartList}`;
      const postData = {
        uuid: redux_fingerprint.fingerprintData,
        channel,
      };
      const response_cart = await axios.post(
        url_cart,
        postData,
        Api.Header(token),
      );
      if (response_cart?.status == 200) {
        setLoading(false);
        const cart = response_cart?.data?.data;
        setCartData(cart);
        dispatch(getCartData(response_cart?.data?.data));
        let result = 0;
        for (const value of cart) {
          const discount =
            value?.product?.web_promotion_product?.web_promotion
              ?.discount_percent ||
            discountAll?.discount_percent ||
            0;
          let sellprice = value?.totalprice;
          if (discount) {
            sellprice = sellprice - (sellprice * discount) / 100;
          }
          result += sellprice;
        }
        setTotalprice(result);
      } else {
        setLoading(false);
      }
    } catch (e) {
      console.log("fetchData >> getCartList error :", e);
    }
  }, [dispatch, redux_fingerprint, token]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchCartData();
    };

    fetchData().catch(console.error);
  }, [fetchCartData]);

  const myLoader = ({ src, width }) => {
    if (src.split("?")?.length > 1) {
      return `${src}`;
    } else {
      const tugen = new ThumborJS(thumborUrl, thumborKey);
      const url = tugen.imgpath(src).resize(width, width).genurl();

      return url;
    }
  };

  const handleRemove = async (cart_id) => {
    setLoading(true);
    const url_cart = `${Api.deleteCart}/${cart_id}`;
    const postData = {
      id: cart_id,
    };
    const response_cart = await axios.delete(url_cart, postData, Api.Header());
    if (response_cart?.status == 200) {
      await fetchCartData(redux_fingerprint.fingerprintData);
    } else {
      setLoading(false);
    }
  };

  const handleQuantity = async (cart, delta) => {
    const current = cart?.number || 0;
    const newQty = current + delta;
    const stock = parseInt(cart?.product?.availablestock || 0, 10);

    if (newQty < 1) return;
    if (newQty > stock) {
      openNotificationError(t("cart-not-enough-stock"));
      return;
    }

    setLoading(true);
    try {
      const url = `${Api.addCart}`;
      const postData = {
        uuid: redux_fingerprint.fingerprintData,
        product_id: cart?.product_id,
        number: delta,
        channel,
      };
      const response = await axios.post(url, postData, Api.Header(token));
      const message = response?.data?.data;
      if (
        typeof message === "string" &&
        message.toLowerCase().includes("out of stock")
      ) {
        openNotificationError(t("cart-not-enough-stock"));
      }
      await fetchCartData(redux_fingerprint.fingerprintData);
    } catch (e) {
      openNotificationError(
        e?.response?.data?.data || t("cart-not-enough-stock"),
      );
      setLoading(false);
    }
  };

  const CartComponent = ({ cart }) => {
    const discount = cart?.discount
      ? cart?.discount[currencyData]?.total_discount
      : 0;

    let totalprice_before_discount = cart?.discount
      ? cart?.discount[currencyData]?.totalprice_before_discount
      : 0;

    let totalprice = cart?.discount
      ? cart?.discount[currencyData]?.totalprice
      : cart?.currency[currencyData]?.totalprice || 0;

    const image_path = cart?.product?.imagepath_compress?.replace(
      /uploads\//g,
      "",
    );
    const imageProduct = cart?.product?.imagepath_compress
      ? `${imageUrl}/${image_path}`
      : cart?.product?.imagepath
        ? cart?.product?.imagepath
        : `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/images/thumbnail.jpeg`;

    return (
      // <Card className="card-cart">
      <Row style={{ marginTop: "24px" }}>
        <Col span={23}>
          <Row
            gutter={[24]}
            justify={`center`}
            className={cart?.product?.availablestock == "0" ? "disable" : ""}
          >
            <Col xs={24} sm={20} md={6} lg={6} xl={5}>
              <div className="cart-image" style={{ textAlign: "center" }}>
                <Image
                  loader={myLoader}
                  src={imageProduct}
                  alt={cart?.product?.name}
                  layout="fill"
                  objectFit="contain"
                />
              </div>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6} xl={7}>
              <Space direction="vertical" style={{ padding: "15px" }}>
                <p className="h5">{cart?.product?.name}</p>
                {/* <Text>{cart?.product?.description}</Text> */}
              </Space>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              {cart?.product?.variant?.length > 0 && (
                <Space
                  direction="vertical"
                  size={`small`}
                  style={{ padding: "15px" }}
                >
                  {cart?.product?.variant?.map((v) => {
                    return (
                      <div key={`cart-${v?.id}`} direction="vertical">
                        <div>
                          {v?.variant_name == "Size" ? (
                            <Text>{t("size")}</Text>
                          ) : v?.variant_name == "Color" ||
                            v?.variant_name == "Colour" ? (
                            <Text>{t("color")}</Text>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          <Text strong style={{ marginTop: 0 }}>
                            {v?.name}
                          </Text>
                        </div>
                      </div>
                    );
                  })}

                  <Space direction="vertical" style={{ gap: "0px" }}>
                    <Text>{t("quantity")}</Text>

                    <div className="cart-qty">
                      <Button
                        className="cart-qty-btn"
                        size="small"
                        icon={<MinusOutlined style={{ fontSize: "10px" }} />}
                        disabled={cart?.number <= 1}
                        onClick={() => handleQuantity(cart, -1)}
                      />
                      <span className="cart-qty-num">{cart?.number}</span>
                      <Button
                        className="cart-qty-btn"
                        size="small"
                        icon={<PlusOutlined style={{ fontSize: "10px" }} />}
                        disabled={
                          cart?.number >=
                          parseInt(cart?.product?.availablestock || 0, 10)
                        }
                        onClick={() => handleQuantity(cart, 1)}
                      />
                    </div>
                  </Space>
                </Space>
              )}
            </Col>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <div style={{ padding: "15px" }}>
                <Text>{t("total-price")}</Text>

                {discount != 0 && (
                  <div>
                    <Text
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        marginBottom: 0,
                      }}
                      delete
                    >{`${currencyAllData[currencyData]?.symbol} ${convert(
                      totalprice_before_discount,
                    )}`}</Text>
                  </div>
                )}
                <p
                  className="h5"
                  style={
                    discount != 0
                      ? { marginTop: 0, color: "rgb(245, 34, 45)" }
                      : { marginTop: 0 }
                  }
                >
                  {convert(totalprice)} {currencyData.toUpperCase()}
                </p>
              </div>
              {cart?.product?.availablestock == 0 ? (
                <div style={{ padding: "15px" }}>
                  <Text type="danger">{t(`Out of stock`)}</Text>
                </div>
              ) : cart?.product?.availablestock < 3 ? (
                <div style={{ padding: "15px" }}>
                  <Text type="danger">
                    {t(`Only ${cart?.product?.availablestock} left`)}
                  </Text>
                </div>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </Col>
        <Col span={1}>
          <DeleteOutlined
            style={{ padding: "15px" }}
            onClick={() => {
              handleRemove(cart?.id);
            }}
          />
        </Col>
      </Row>
      // </Card>
    );
  };

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Cart</title>
      </Head>
      <Spin spinning={loading}>
        <Row style={{ marginTop: 24, marginBottom: 24 }} justify="center">
          <Col xs={22} sm={22} md={22} lg={20} xl={20}>
            <p className="h4">{t("cart-shopping-bag")}</p>
            <Row justify={`center`} gutter={[24, 24]}>
              <Col
                xs={24}
                sm={24}
                md={20}
                lg={18}
                xl={19}
                style={{ marginTop: 24 }}
              >
                <Row justify={`space-between`}>
                  <Divider style={{ marginBottom: 15, marginTop: 0 }} />
                </Row>
                {cartData?.map((cart) => {
                  return <CartComponent key={`cart-${cart?.id}`} cart={cart} />;
                })}

                {cartData?.length == 0 && (
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: 200,
                    }}
                  >
                    <ShoppingOutlined
                      style={{ fontSize: 48, color: "#bfbfbf" }}
                    />
                    <Text>{t("cart-your-bag-is-empty")}</Text>
                  </Space>
                )}
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={6}
                xl={5}
                style={{ marginTop: 24 }}
              >
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Summary
                    t={t}
                    discountAll={discountAll}
                    setLoading={setLoading}
                    token={token}
                  />
                  <Button
                    className="btn-add"
                    block
                    size="large"
                    disabled={cartData?.length == 0}
                    onClick={async () => {
                      let error = false;
                      await Promise.all(
                        await cartData?.map(async (cart) => {
                          if (cart?.product?.availablestock == 0) {
                            error = true;
                            openNotificationError(
                              t(`${cart?.product?.product_name} Out of stock`),
                            );
                          }
                        }),
                      );
                      if (!error) {
                        // gtag_report_conversion();
                        router.push(
                          `/checkout${queryParam ? `?${queryParam}` : ``}`,
                        );
                      }
                    }}
                  >
                    {t("cart-checkout")}
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </App>
  );
};

export default Home;
